// Site-wide event settings.
// Set COMING_SOON to false when the full website is ready to go live again:
// it brings back the navigation, register buttons and all hidden pages.
export const COMING_SOON = true;

export const EVENT_DATE = '23rd January 2027';
export const EVENT_YEAR = '2026';
export const CALL_FOR_SPEAKERS_URL = 'https://sessionize.com/devfest-london-2026/';
